export function toMarkdown(markdownStr) {
    return markdownStr.replace(/\n/g, ' \r\n');
}